import React, { useState } from 'react';
import { Form } from '../../components/forms/form';
import { TextInput } from '../../components/forms/input';
import Logo from '../../assets/icons/logo.svg';
import Show from '../../assets/icons/show.svg';
import authService from './auth-service';
import { Modes } from '../../types/page-modes';

type FormData = {
  system: string;
  username: string;
  password: string;
};

const formState = {
  system: '',
  username: '',
  password: '',
};

export const Login = (): JSX.Element => {
  const [mode, setMode] = useState<Modes>(Modes.BROWSE);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [formData, setFormData] = useState<FormData>(formState);
  const [passwordFieldType, setPasswordFieldType] = useState<string>('password');

  const onChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const onPasswordClick = (): void => {
    setPasswordFieldType(passwordFieldType === 'password' ? 'text' : 'password');
  };

  const authenticate = async (): Promise<void> => {
    try {
      setMode(Modes.FETCHING);
      await authService.logIn(formData);
      window.location.pathname = '/';
    } catch (exception: any) {
      setMode(Modes.WITH_ERROR);
      setErrorMessage(exception.message as string);
    }
  };

  return (
    <div className="login-container d-flex">
      <div className="login-form-container">
        <div className="login-logo">
          <img src={Logo} alt="Logo" />
        </div>
        <Form onSubmit={authenticate} className="login-form">
          <h2 className="page-title mb-4">Log In</h2>
          {mode === Modes.WITH_ERROR ? (
            <div className="alert alert-danger" role="alert">
              {errorMessage}
            </div>
          ) : null}
          <div className="mb-4">
            <TextInput name="system" value={formData.system} onChange={onChange} required />
          </div>
          <div className="mb-4">
            <TextInput name="username" value={formData.username} onChange={onChange} required />
          </div>
          <div className="mb-4">
            <div className="position-relative">
              <TextInput
                name="password"
                value={formData.password}
                onChange={onChange}
                type={passwordFieldType}
                required
              />
              <img
                src={Show}
                alt="Change Password Type"
                className="toggle-password-visibility"
                onClick={onPasswordClick}
              />
            </div>
          </div>
          <button
            className="btn btn-primary btn-lg login-btn w-100 mt-3 mb-5"
            disabled={mode === Modes.FETCHING}>
            Log In
          </button>
          <p className="mt-5 dark-blue">Fostering Disaster Resilient Communities</p>
          <p className="gray-2">Rev: {process.env.REACT_APP_VERSION}</p>
        </Form>
      </div>
      <div className="login-cover" />
    </div>
  );
};
